module.exports = __webpack_public_path__ + "img/DB1_LOGO_DARK.124a1aa9.png";